

export default ({ workspaces, selectWorkspace }) => {

	let localClickEvent = (e, workspace) => {
		e.preventDefault();
		return selectWorkspace && selectWorkspace(workspace)
	}

	return (
		<div className="row">
			<div className="col-12 text-center" style={{ color: "white" }}>
				<h6>Which EMAPTA CHEER user type are you? </h6>
			</div>

			{workspaces ?
				workspaces.map(workpace => {
					if (![6].includes(workpace.workspace_id)) {
						return (
							<div key={workpace.workspace_id} className="col-lg-4 col-md-4 col-xs-12">
								<a href={null} onClick={e => localClickEvent(e, workpace)}>
									<div className="card mt-3">
										<div className="card-body text-center">
											{workpace.workspace_name}
										</div>
									</div>
								</a>
							</div>
						)
					}

				})
				: null}

			<div className="col-12 text-center mt-5" style={{ color: "white" }}>
				<hr />
				<h6>Other Categories</h6>
			</div>
			{workspaces ?
				workspaces.map(workpace => {
					if ([6].includes(workpace.workspace_id)) {
						return (
							<div key={workpace.workspace_id} className="col-lg-4 col-md-4 col-xs-12">
								<a href={null} onClick={e => localClickEvent(e, workpace)}>
									<div className="card mt-3">
										<div className="card-body text-center">
											{workpace.workspace_name}
										</div>
									</div>
								</a>
							</div>
						)
					}

				})
				: null}
		</div>
	)
}